import { useState } from "react";
import type { Video } from "@/mocks/videos";
import { formatDuration } from "@/lib/videos";

export default function PlayerMock({ video }: { video: Video }) {
  const [showNote, setShowNote] = useState(true);

  return (
    <div className="rounded-lg overflow-hidden border border-background-200/70 bg-background-950">
      <div className="relative w-full aspect-video">
        <img
          src={video.cover}
          alt={`${video.title} 预览封面`}
          title={`${video.title} 演示预览画面`}
          className="w-full h-full object-cover object-top opacity-45"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/60 to-background-950/30" />
        <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
          <button
            type="button"
            onClick={() => setShowNote(true)}
            className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary-500/90 hover:bg-primary-500 flex items-center justify-center text-background-50 transition-colors cursor-pointer"
            aria-label="播放演示"
          >
            <i className="ri-play-fill text-3xl md:text-4xl" />
          </button>
          <p className="mt-4 text-sm text-foreground-100">本站演示 · 非真实播放</p>
          <p className="mt-1.5 text-xs text-foreground-500 max-w-md leading-relaxed">
            该区域仅展示作品封面与播放界面示意，不提供真实视频流。完整作品请通过正规授权渠道观看。
          </p>
        </div>

        <div className="absolute left-0 right-0 bottom-0 h-1 bg-foreground-50/10">
          <div className="h-full w-1/6 bg-primary-500" />
        </div>

        <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2 py-1 rounded-sm bg-background-950/80 text-[11px] text-foreground-200">
          <i className="ri-camera-line" />
          预览演示
        </div>
        <div className="absolute top-3 right-3 px-2 py-1 rounded-sm bg-background-950/80 text-[11px] text-foreground-300 font-label tracking-wider">
          {formatDuration(video.duration)}
        </div>
      </div>

      {showNote && (
        <div className="flex items-start gap-2 px-4 py-3 border-t border-background-200/70 bg-background-100">
          <i className="ri-information-line text-accent-400 mt-0.5" />
          <p className="text-xs text-foreground-400 leading-relaxed flex-1">
            演示说明：本页面为产品原型演示，播放按钮不会加载任何真实视频，仅用于展示信息结构与交互位置。
          </p>
          <button
            type="button"
            onClick={() => setShowNote(false)}
            className="text-[11px] text-foreground-500 hover:text-foreground-100 whitespace-nowrap cursor-pointer"
          >
            知道了
          </button>
        </div>
      )}
    </div>
  );
}